import React from "react";
import { WorkProjectData } from "./Workdata";
import { WorkNavData } from "./Workdata";
import { useState } from "react";
import { useEffect } from "react";
import Workitem from "./Workitem";
import ScrollTrigger from "react-scroll-trigger";

const Work = () => {
  const [animationOn, setAnimationOn] = useState(false);
  const [item, setItem] = useState({ name: "all" });
  const [projects, setProjects] = useState([]);
  const [active, setActive] = useState(0);

  useEffect(() => {
    if (item.name === "all") {
      setProjects(WorkProjectData);
    } else {
      const newProjects = WorkProjectData.filter((project) => {
        return project.category == item.name;
      });
      setProjects(newProjects);
    }
  }, [item]);

  const handleClick = (e, ind) => {
    setItem({ name: e.target.textContent });
    setActive(ind);
  };

  return (
    <div className="portfolioContent">
      <div className="workFilters">
        {WorkNavData.map((nav, ind) => {
          const { name } = nav;
          return (
            <span
              onClick={(e) => handleClick(e, ind)}
              key={ind}
              className={
                active !== ind ? "workNavItem" : "workNavItem activeBar"
              }
            >
              {name}
            </span>
          );
        })}
      </div>

      <ScrollTrigger
        onEnter={() => setAnimationOn(true)}
        onExit={() => setAnimationOn(false)}
      >
        {animationOn && (
          <div className="projects animate__animated animate__flipInX">
            {projects.map((work) => {
              return <Workitem work={work} key={work.id} />;
            })}
          </div>
        )}
      </ScrollTrigger>
    </div>
  );
};

export default Work;
